"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WorkOrdersModule = /** @class */ (function () {
    function WorkOrdersModule() {
    }
    return WorkOrdersModule;
}());
exports.WorkOrdersModule = WorkOrdersModule;
